import { render } from "./VentasEditarView.vue?vue&type=template&id=72a1b10c&ts=true"
import script from "./VentasEditarView.vue?vue&type=script&lang=ts"
export * from "./VentasEditarView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__